import Styles from './UserLearningPath.module.scss';
import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Components import.
import { useAPI, Message, AuthContext } from 'components/lib';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { CertLearningPath } from 'components/global/LearningPath/CertLearningPath';

const handleLabClick = (data, navigator, is_cert = 0, cert_id = false) => {

    const id = data.id;
    const labStatus = data.status;
    // Encrypt function to certificate id
    const encrypt = (text) => {
        return CryptoJS.AES.encrypt(text, 'secretKey').toString();
    };
    const options = {
        method: "POST",
        url: `/api/user/labs/${id}/assign/${is_cert}`,
        headers: {
            "accept": "application/json",
        },
        params: cert_id ? { certId: cert_id } : {},
    };

    if (labStatus === "not_started") {
        axios
            .request(options)
            .then(async function (response) {
                cert_id && sessionStorage.setItem("certID", encrypt(cert_id));
                await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
                navigator(`/labs/${id}/nodes`);
            })
            .catch((err) => {
                let status = err.response.status;
                console.log("error", status);
                navigator('/oops');
            });
    } else {
        cert_id && sessionStorage.setItem("certID", encrypt(cert_id));
        navigator(`/labs/${id}/nodes`);
    }
};

export function UserLearningPath(props) {
    const { lpath_id } = useParams();
    const navigate = useNavigate()

    const searchParams = new URLSearchParams(window.location.search);
    const lab_id = Number(searchParams.get('lab'));

    const { data, loading } = useAPI(`/api/user/lpath/${lpath_id}/labs`, 'GET');

    const [userLabs, setUserLabs] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const context = useContext(AuthContext)
    const [showNotOnboardedDialog, setShowNotOnboardedDialog] = useState(false);

    useEffect(() => {
        if (userLabs.length > 0 && lab_id !== undefined) {
            if (lab_id >= 0 && lab_id < userLabs.length) {
                setActiveStep(lab_id)
            } else {
                navigate(`/lpaths/${lpath_id}/learningpath`)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userLabs])

    useEffect(() => {
        if (data) {
            setUserLabs(data.labs);
        }
    }, [data]);


    const handleStep = (step) => {
        setActiveStep(step);
    };


    //handle the generate link
    const handleCertificateClick = async () => {
        navigate(`/certificate/${data?.user_cert_id}`)
    };

    //converting the due date into dd-mm-yyy format
    var date = data?.cert_due_date && new Date(data?.cert_due_date);
    var dueDate = data?.cert_due_date && date.toLocaleDateString(
        'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }
    );

    return (
        <div data-testid="userLearningPath-ancestorLearner" id="ancestorLearner" className={Styles.ancestorLearner}>
            {(data?.certificate) &&
                <Message
                    closable
                    title={props.t('LearningPath.UserLearningPath.message.title')}
                    text={props.t('LearningPath.UserLearningPath.message.descr')}
                    type="success"
                />}
            {loading ? (
                <div>
                    <LoadingBackdrop isOpen={true} />
                </div>
            ) : userLabs.length > 0 ? (
                <>
                    <div data-testid="userLearningPath-certOverview" className={Styles.certOverview} id="certOverview">
                        <div data-testid="userLearningPath-breadcrumbContainer" id='breadcrumbContainer' className={Styles.breadcrumbContainer}>
                            <BreadCrumbs
                                onClickPaths={[
                                    '/lpaths',
                                    ''
                                ]}
                                crumbs={[
                                    props.t('LearningPath.UserLearningPath.breadcrumbs.lpaths'),
                                    data?.certName ? data.certName : props.t('LearningPath.UserLearningPath.breadcrumbs.lpath')
                                ]}
                            />
                        </div>
                    </div>

                    <div>
                        <CertLearningPath
                            data={data}
                            dueDate={dueDate}
                            context={context}
                            setShowNotOnboardedDialog={setShowNotOnboardedDialog}
                            showNotOnboardedDialog={showNotOnboardedDialog}
                            onHandleCertificateClick={handleCertificateClick}
                            activeStep={activeStep}
                            userLabs={userLabs}
                            onHandleStep={handleStep}
                            onHandleLabClick={handleLabClick}
                            lpath_id={lpath_id}
                            expiredRedirection={`/lpaths/info/${lpath_id}`}
                            t={props.t}
                        />
                    </div>
                </>
            ) : (<>
                {props.t('LearningPath.UserLearningPath.noLabs')} </>)
            }
        </div >
    )
}
